import { Model } from 'modules/core/lib/mobx-rest'

export interface ICompanyLink {
  id?: string
  name: string
  url: string
  order: number
  draft?: boolean
  delete?: boolean
}

export class CompanyLink extends Model<ICompanyLink> {
  static urlRoot() {
    return '/dashboard/company_links'
  }

  constructor(data: ICompanyLink) {
    super(data)
  }
}
